<div class="banners-container-outer">
    <div class="banners-container-inner">
        <ion-row class="ion-margin-top ion-no-padding banner-blocks" *ngIf="this.banners">

            <ion-col size="12" class="banner ion-no-padding  ion-no-margin" *ngIf="this.banners[0]">
                <a href="javascript:void(0)" (click)="mainBannerClick(this.banners[0].vacation_banner_url)">
                    <img src="{{ this.banners[0].vacation_banner }}" style="max-width:100%; max-height:100%;">
                </a>
            </ion-col>

        </ion-row>
        <ion-row class="ion-no-padding" *ngIf="this.banners">
            <div class="banners-wrapper">
                <div class="banner" *ngIf="this.banners[1]">
                    <a href="javascript:void(0)" (click)="mainBannerClick(this.banners[1].vacation_banner_url)">
                        <img src="{{ this.banners[1].vacation_banner }}" style="max-width:100%; max-height:100%;">
                    </a>
                </div>

                <div class="banner" *ngIf="this.banners[2]">
                    <a href="javascript:void(0)" (click)="mainBannerClick(this.banners[2].vacation_banner_url)">
                        <img src="{{ this.banners[2].vacation_banner }}" style="max-width:100%; max-height:100%;">
                    </a>
                </div>
            </div>


        </ion-row>

    </div>
</div>





